import { BASE_URL } from '../../../config/environmentConfig';
import {
	faAddressBook,
	faBalanceScale,
	faBarChart,
	faBolt,
	faBriefcase,
	faCartShopping,
	faCode,
	faCoins,
	faCreditCardAlt,
	faFingerprint,
	faHandshakeSimple,
	faKey,
	faSliders,
	faStore,
	faUser,
	faCircleExclamation,
} from '@fortawesome/free-solid-svg-icons';
import { CLAIMS } from '../../utils/roles-helper';
import { ROUTES } from '../../routing/routesEnums';

export const asideMenuItems = [
	{
		claim: CLAIMS.SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_PARTNER_ADMIN,
		title: 'MENU.DASHBOARD',
		path: '/dashboard',
		icon: faBarChart
	},
	{
		claim: CLAIMS.SUPER_ADMIN_AND_ONLY_PARTNER_ADMIN,
		title: 'Analytics',
		path: '/analytics',
		icon: faBarChart
	},
	{
		claim: CLAIMS.SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_PARTNER_ADMIN,
		title: 'MENU.ORDERS',
		path: '/orders',
		icon: faCartShopping,
	},
	{
		claim: CLAIMS.SUPER_ADMIN,
		title: 'MENU.DISPUTES',
		path: ROUTES.DISPUTES,
		icon: faCreditCardAlt,
		subMenuItems: [
			{
				title: 'MENU.ALL',
				path: `${ROUTES.DISPUTES}${ROUTES.DISPUTES_ALL}`,
			},
			{
				title: 'MENU.DISPUTES_QUEUE',
				path: '/disputes/queues',
			},
			{
				title: 'MENU.DISPUTES_ARCHIVE',
				path: '/disputes/archived',
			}
		]
	},
	{
		claim: CLAIMS.PARTNER_ADMIN,
		title: 'MENU.DISPUTES',
		path: '/disputes',
		icon: faCreditCardAlt,
	},
	{
		claim: CLAIMS.INTEGRATION_PARTNER_ADMIN,
		title: 'MENU.DISPUTES',
		path: '/disputes',
		icon: faCreditCardAlt,
	},

	{
		claim: CLAIMS.MERCHANT_ADMIN,
		title: 'MENU.SETTLEMENTS',
		path: ROUTES.SETTLEMENTS,
		icon: faBalanceScale
	},
	{
		claim: CLAIMS.SUPER_ADMIN,
		title: 'MENU.FUNDS',
		path: ROUTES.FUNDS,
		icon: faCoins,
		subMenuItems: [
			{
				title: 'MENU.PAYOUTS',
				path: `${ROUTES.FUNDS}${ROUTES.BATCHES}${ROUTES.UNPOSTED}`,
			},
			{
				title: 'MENU.SETTLEMENTS',
				path: `${ROUTES.FUNDS}${ROUTES.SETTLEMENTS}${ROUTES.LATEST_SETTLEMENTS}`,
			},
			{
				title: 'MENU.FUNDS_RESERVE',
				path: '/funds/funds-reserve',
			},
			{
				title: 'MENU.FINANCIAL_ACCOUNT',
				path: '/funds/finance',
			},
		]
	},
	{
		claim: CLAIMS.PARTNER_ADMIN,
		title: 'MENU.FUNDS',
		path: '/funds',
		icon: faCoins,
		subMenuItems: [
			{
				title: 'MENU.PAYOUTS',
				path: `${ROUTES.FUNDS}${ROUTES.BATCHES}${ROUTES.UNPOSTED}`,
			},
			{
				title: 'MENU.SETTLEMENTS',
				path: `${ROUTES.FUNDS}${ROUTES.SETTLEMENTS}${ROUTES.LATEST_SETTLEMENTS}`,
			},
			{
				title: 'MENU.FUNDS_RESERVE',
				path: '/funds/funds-reserve',
			},
		]
	},
	{
		claim: CLAIMS.SUPER_ADMIN_AND_MERCHANT_ADMIN_AND_PARTNER_ADMIN,
		title: 'MENU.USERS',
		path: '/users',
		icon: faUser
	},
	{
		claim: CLAIMS.SUPER_ADMIN,
		title: 'MENU.PARTNERS',
		path: '/partners',
		icon: faHandshakeSimple
	},
	{
		claim: CLAIMS.SUPER_ADMIN,
		title: 'MENU.CONTACTS',
		path: '/contacts',
		icon: faAddressBook
	},
	{
		claim: CLAIMS.SUPER_ADMIN,
		title: 'MENU.AGENCY',
		path: '/agencies',
		icon: faBriefcase,
		subMenuItems: [
			{
				title: 'MENU.AGENCY',
				path: '/agencies/agencies'
			},
			{
				title: 'MENU.COMMISSIONS',
				path: '/agencies/commissions'
			},
			{
				title: 'MENU.DEALS',
				path: '/agencies/deals'
			},
		]
	},
	{
		claim: CLAIMS.SUPER_ADMIN_AND_MERCHANT_ADMIN,
		title: 'MENU.RISK',
		path: '/risk',
		icon: faFingerprint,
		subMenuItems: [
			{
				title: 'BLOCK_LIST.SECTION_TITLE',
				path: '/risk/block-list'
			},
			{
				title: 'MENU.FUNDS_RESERVE_CONFIG',
				path: '/risk/reserve-config'
			}
		]
	},
	// TODO Remove when BLOCK_LIST will be fixed in partner portal
	{
		claim: CLAIMS.PARTNER_ADMIN,
		title: 'MENU.RISK',
		path: '/risk',
		icon: faFingerprint,
		subMenuItems: [
			// {
			// 	title: 'BLOCK_LIST.SECTION_TITLE',
			// 	path: '/risk/block-list'
			// },
			{
				title: 'MENU.FUNDS_RESERVE_CONFIG',
				path: '/risk/reserve-config'
			}
		]
	},
	// {
	// 	claim: CLAIMS.INTEGRATION_PARTNER_ADMIN,
	// 	title: 'MENU.RISK',
	// 	path: '/risk',
	// 	icon: faFingerprint,
	// 	subMenuItems: [
	// 		// {
	// 		// 	title: 'BLOCK_LIST.SECTION_TITLE',
	// 		// 	path: '/risk/block-list'
	// 		// },
	// 		{
	// 			title: 'MENU.FUNDS_RESERVE_CONFIG',
	// 			path: '/risk/reserve-config'
	// 		}
	// 	]
	// },

	{
		claim: CLAIMS.SUPER_ADMIN_AND_PARTNER_ADMIN,
		title: 'MENU.ACCOUNTS',
		path: '/accounts',
		icon: faStore,
		subMenuItems: [
			{
				title: 'MENU.ACCOUNTS',
				path: '/accounts/accounts'
			},{
				title: 'MENU.ALL_APPLICATIONS',
				path: '/accounts/applications'
			},
			{
				title: 'MENU.MERCHANTS',
				path: '/accounts/merchants'
			}
		]
	},
	{
		claim: CLAIMS.MERCHANT_ADMIN,
		title: 'MENU.DEVELOPERS',
		path: '/developers',
		icon: faCode,
		subMenuItems: [
			{
				title: 'MENU.WEBHOOKS',
				path: '/developers/webhooks',
				isForPartner: false
			},
			{
				title: 'MENU.SFTP',
				path: '/developers/sftp'
			},
			{
				title: 'MENU.SITES',
				path: '/developers/sites',
				isForPartner: false
			},
			{
				title: 'MENU.API_KEYS',
				path: '/developers/api-keys',
				isForPartner: false
			},
			{
				isLink: true,
				title: 'MENU.DOCUMENTATION',
				path: BASE_URL.DOCS_URL,
				isForPartner: true
			},
			{
				title: 'MENU.LOGS',
				path: '/developers/logs',
				isForPartner: false
			}
		]
	},

	{
		claim: CLAIMS.SUPER_ADMIN,
		title: 'MENU.ADMIN',
		path: '/admin',
		icon: faKey,
		subMenuItems: [
			{
				title: 'MENU.WEBHOOKS_ACTIVITY',
				path: '/admin/webhooks-activity'
			},
			{
				title: 'MENU.TRANSACTIONS',
				path: '/admin/transactions'
			},
			{
				title: 'MENU.ACTIVITY_LOG',
				path: '/admin/activity-log'
			},
			{
				title: 'MENU.REPORTS',
				path: '/admin/reports'
			},
			{
				title: 'MENU.PROVIDER',
				path: `${ROUTES.ADMIN}${ROUTES.PROVIDERS}${ROUTES.PROCESSING}`
			},
			{
				title: 'MENU.DISPUTES_ALERT_PROVIDERS',
				path: '/admin/alert-providers'
			},
			// {
			// 	title: 'MENU.FEE_CONFIGURATION',
			// 	path: '/admin/fee-configuration'
			// },
			{
				title: 'MENU.API_CLIENTS',
				path: '/admin/api-clients'
			},
			{
				title: 'MENU.AUDIT_LOGS',
				path: '/admin/audit-logs'
			},
		]
	},
	{
		claim: CLAIMS.PARTNER_ADMIN,
		title: 'MENU.WEBHOOKS_ACTIVITY',
		path: '/webhooks-activity',
		icon: faBolt,
	},
	{
		claim: CLAIMS.PARTNER_ADMIN,
		title: 'MENU.DISPUTES_ALERT_PROVIDERS',
		path: '/alert-providers',
		icon: faCircleExclamation,
	},
	{
		claim: CLAIMS.PARTNER_ADMIN,
		title: 'MENU.FEE_CONFIGURATION',
		path: '/fee-configuration',
		icon: faSliders,
	},
	{
		claim: CLAIMS.INTEGRATION_PARTNER_ADMIN,
		title: 'MENU.WEBHOOKS_ACTIVITY',
		path: '/webhooks-activity',
		icon: faBolt,
	},

	// {
	// 	claim: CLAIMS.MERCHANT_FINANCE,
	// 	title: 'MENU.COMMISSIONS',
	// 	path: '/commissions',
	// 	icon: faStore
	// },
	// {
	// 	claim: CLAIMS.MERCHANT_FINANCE,
	// 	title: 'MENU.DEALS',
	// 	path: '/deals',
	// 	icon: faStore
	// },
	// {
	// 	isForAdmin: true,
	// 	isForMerchant: false,
	// 	isForPartnerAdmin: false,
	// 	title: 'User Settings',
	// 	path: '/user-settings/profile',
	// 	icon: '/media/icons/merchants-icon.svg'
	// },

	{
		claim: CLAIMS.MERCHANT_ADMIN,
		title: 'MENU.PLATFORMS',
		path: '/platforms',
		icon: faCreditCardAlt,
	},
];

export const developersAsideMenuItems = [
	{
		claim: CLAIMS.ALL_MERCHANT_DEVELOPERS_ROLES,
		title: 'MENU.DASHBOARD',
		path: '/dashboard',
		icon: faBarChart
	},
	{
		claim: CLAIMS.ALL_MERCHANT_DEVELOPERS_ROLES,
		title: 'MENU.ORDERS',
		path: '/orders',
		icon: faCartShopping,
	},
	{
		claim: CLAIMS.ALL_MERCHANT_DEVELOPERS_ROLES,
		title: 'MENU.SETTLEMENTS',
		path: `${ROUTES.SETTLEMENTS}${ROUTES.LATEST_SETTLEMENTS}`,
		icon: faBalanceScale
	},
	{
		claim: CLAIMS.ALL_MERCHANT_DEVELOPERS_ROLES,
		title: 'MENU.USERS',
		path: '/users',
		icon: faUser
	},
	{
		claim: CLAIMS.ALL_MERCHANT_DEVELOPERS_ROLES,
		title: 'MENU.RISK',
		path: '/risk',
		icon: faFingerprint,
		subMenuItems: [
			{
				title: 'BLOCK_LIST.SECTION_TITLE',
				path: '/risk/block-list'
			},
			// {
			// 	title: 'MENU.FUNDS_RESERVE_CONFIG',
			// 	path: '/risk/reserve-config'
			// }
		]
	},
	{
		claim: CLAIMS.ALL_MERCHANT_DEVELOPERS_ROLES,
		title: 'MENU.DEVELOPERS',
		path: '/developers',
		icon: faCode,
		subMenuItems: [
			{
				title: 'MENU.WEBHOOKS',
				path: '/developers/webhooks',
				isForPartner: false
			},
			{
				title: 'MENU.SFTP',
				path: '/developers/sftp'
			},
			{
				title: 'MENU.SITES',
				path: '/developers/sites',
				isForPartner: false
			},
			{
				title: 'MENU.API_KEYS',
				path: '/developers/api-keys',
				isForPartner: false
			},
			{
				isLink: true,
				title: 'MENU.DOCUMENTATION',
				path: BASE_URL.DOCS_URL,
				isForPartner: true
			},
			{
				title: 'MENU.LOGS',
				path: '/developers/logs',
				isForPartner: false
			}
		]
	},
	{
		claim: CLAIMS.MERCHANT_ADMIN,
		title: 'MENU.PLATFORMS',
		path: '/platforms',
		icon: faCreditCardAlt,
	},
];
